<template>
  <div class="page-block">
    <div class="page-block">
      <header-bar v-if="isLoggedIn">ヘルプ</header-bar>
      <div class="page-block__heading page-block__heading--withbar">
        <h3 class="page-block__title">ストア詳細</h3>
      </div>
      <div class="page-block__inner">
        <div class="store-detail-area">
          <div
            v-for="item in lists"
            :key="item.id"
            class="store-detail-area__block">
            <div class="store-detail-area__block--left">
              <img
                :src="`/img/common/company/${item.logo}`"
                style="max-height: 200px;max-width: 200px"
                alt="">
            </div>
            <div
              class="store-detail-area__block--right">
              <h3 class="store-detail-area__block--right--name">
                {{ item.name }}
              </h3>
              <p
                class="store-detail-area__block--right--details">
                {{ item.description }}
              </p>
            </div>
            <div class="store-detail-area__block--details">
              <p
                v-if="item.note !== ''"
                class="store-detail-area__block--right--details">
                {{ item.note }}
              </p>
            </div>
          </div>
          <p class="store-detail-area__block--annotation">
            ※1.ラジオ型とは、1曲ごとにダウンロードやストリーミングするのではなく、聴き手の好みに合った楽曲が次々と自動的に流れるサービスです
          </p>
          <div class="c-btn-wrap c-btn-wrap-faq">
            <router-link
              :to="{ name: 'index' }"
              class="c-btn c-btn--back">
              トップへ戻る
              <span class="c-btn__icon-arrow c-btn__icon-arrow--left"></span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import HeaderBar from '../HeaderBar'

export default {
  name: 'StoreDetail',
  components: { HeaderBar },
  data() {
    return {
      lists: [
        {
          id: 0,
          business_direction: 'all',
          logo: 'logo_spotify.jpg',
          name: 'Spotify',
          description: '配信形式：ストリーミング\n配信地域：国内/海外\n試聴時間：試聴機能なし',
          note: 'Spotify（スポティファイ）は、スウェーデンの企業スポティファイ・テクノロジーによって運営されている音楽ストリーミングサービスです。音楽配信サービスとしては世界最大手であり、日本では2016年9月にサービスが開始されました。\nアクティブユーザー数は3億6500万人。パソコン、携帯電話、タブレット、スピーカー、テレビ、車など、さまざまな種類のデバイスで利用可能、5000 万以上の音楽やコンテンツが揃っています。 また、友達、アーティスト、セレブが作ったプレイリストを聴いたり、専用ラジオステーションを作成することもできます。\n音楽再生などの基本的機能は無料、希望に応じてSpotify Premiumにアップグレードが可能です。\nPremiumのみで利用できる機能としては、再生する曲の自由選択や曲順の変更に加え、端末に楽曲を落としてオフラインで再生する機能や、対応するワイヤレス機器やネットワーク機器から直接ログインして再生するSpotify Connectが挙げられます。',
        },
        {
          id: 1,
          business_direction: 'all',
          logo: 'logo_applemusic.jpg',
          name: 'Apple Music',
          description: '配信形式：ストリーミング\n配信地域：国内/海外\n試聴時間：試聴機能なし',
          note: 'Apple Musicは7,500万曲以上をそろえた音楽ストリーミングサービスです。アクティブユーザー数は約7,200万人。ストリーミングプラットフォーム、スマートスピーカー、AndroidおよびWindowsデバイスで再生可能、オフライン再生という機能を利用することで、ダウンロードしておけば外で通信量をかけずに楽曲を楽しむ事ができます。音楽以外にも、ミュージックビデオや独自の番組を視聴可能です。\nApple Musicでは平面的ではなく立体的に音楽を体感できる「ドルビーアトモス」や楽曲のデータを圧縮せずにアーティストがスタジオで制作した音と変わらない音質で視聴ができる「ロスレスオーディオ」に対応しています。またインターネットラジオ局の「Apple Music 1」、「Apple Music Hits」、「Apple Music Country」が含まれており、24時間体制で200カ国以上に向けて生放送を行っています。',
        },
        {
          id: 2,
          business_direction: 'all',

          logo: 'logo_itunesstore.jpg',
          name: 'iTunes Store',
          description: '配信形式：ダウンロード\n配信地域：国内/海外\n試聴時間：90秒\n※2分30秒未満の楽曲は30秒',
          note: 'iTunes Store（アイチューンズ・ストア）とは、Appleが運営している音楽配信、動画配信、映画配信、映画レンタル、アプリケーション提供などを行うコンテンツ配信サービスです。ミュージックを一曲単位、あるいはアルバム単位で購入でき、認証したデバイスならいつでも購入した曲を聴くことが可能です。購入した曲はDRMフリーとなっており、使用制限がないことが特長です。購入・ダウンロードした音楽データはユーザーの所有物となるので基本的にずっと利用することができます。端末を切り替えたとしても、iTunes Storeで購入した楽曲なら所有権を保有しているため、再度ダウンロードすることで音楽を聴くことが可能です。',
        },
        {
          id: 3,
          business_direction: 'all',
          logo: 'logo_amazon_unlimited.jpg',
          name: 'Amazon Music Unlimited',
          description: '配信形式：ストリーミング\n配信地域：国内/海外\n試聴時間：試聴機能なし',
          note: 'Amazon Music Unlimitedは7,000万曲の楽曲やプレイリスト、ラジオなどを楽しめる音楽配信サービスです。Amazon musicの利用者は5500万人を超えており、パソコン、Fireタブレット、Fire TVシリーズ、iPhone/iPad、Android端末、さらにAmazon EchoなどのAlexa対応機器で、いつでもどこでも音楽を聴くことが可能です。楽曲と楽曲の間に広告が流れることはなく、楽曲をモバイル端末にダウンロードすれば、インターネット接続がなくても聴くことができます。',
        },
        {
          id: 4,
          business_direction: 'all',
          logo: 'logo_amazon_music.jpg',
          name: 'Amazonデジタルミュージックストア',
          description: '配信形式：ダウンロード\n配信地域：国内/海外\n試聴時間：30秒',
          note: 'AmazonデジタルミュージックストアはAmazon公式のデジタルストアです。ニューリリース、人気のアルバム、楽曲をダウンロード可能です。無料のAmazon Musicアプリをダウンロードすれば、お気に入りをいつでもどこでも楽しめます。',
        },
        {
          id: 5,
          business_direction: 'all',
          logo: 'logo_prime_music.jpg',
          name: 'Prime Music',
          description: '配信形式：ストリーミング\n配信地域：国内/海外',
          note: 'prime musicはAmazon プライム会員の無料特典のひとつです。Amazon プライム会員として年会費あるいは月会費を支払っていれば、追加料金なしで楽しめます。200万曲の楽曲のほか、何千ものプレイリスト、カスタマイズされたストリーミング再生ラジオを再生可能で、広告なしで楽しめます。また、曲のお気に入り登録も可能であり、好きな曲を集めた自分だけのプレイリストを作って、好きなときに再生することができます。',
        },
        {
          id: 6,
          business_direction: 'all',
          logo: 'logo_awa.jpg',
          name: 'AWA',
          description: '配信形式：ストリーミング\n配信地域：国内\n試聴時間：30秒',
          note: 'AWA（アワ）は、サイバーエージェントとエイベックス・デジタルの共同出資によって設立されたAWA株式会社が提供する音楽ストリーミングサービスです。取り扱い楽曲数は世界最大規模の9000万曲。邦楽・洋楽・メジャー・インディーズ・年代問わず配信しています。\n日本発の音楽サービスのため、日本人アーティストの楽曲が充実していることが「AWA」の魅力のひとつです。たとえば、演歌のような、他サービスではなかなかないジャンルの楽曲も充実しています。自分の好きな曲を集めたオリジナルのプレイリストを作成することもできます。また、作成したプレイリストは、他のAWAユーザーも聴けるように公開可能です。他の人のプレイリストから、自分の好きな曲を探すこともできます。',
        },
        {
          id: 7,
          business_direction: 'all',
          logo: 'logo_line_music.jpg',
          name: 'LINE MUSIC',
          description: '配信形式：ストリーミング\n配信地域：国内\n試聴時間：30秒',
          note: '「LINE MUSIC」は、邦楽・洋楽問わず8200万曲以上の幅広いジャンルの楽曲を、利用シーンや気分に応じて、いつでもどこでも音楽を聴くことができる日本発の音楽ストリーミングサービスです。音楽を通じたコミュニケーションがよりユーザー間の仲を深め、特別な音楽との出会いにも繋がると考え、「LINE」上でLINE MUSICが配信する楽曲をシェアできたり、無料通話をかけた相手に聴こえる“呼出音”を設定したりできる「LINE着うた® 」、好きな楽曲をプロフィールに設定できる「プロフィールBGM」など、独自機能の開発を重ねています。現在ではプロフィールBGM設定ユーザーは1,200万人を越え、アプリダウンロード数は3,700万件を突破。「カラオケ機能」（楽曲のボーカルをオフにして、ユーザーの歌声を音源にミックスして再生させることでカラオケさながらの体験を楽しめる機能）や楽曲サーチ（いま流れているこの楽曲を知りたい」と思ったときに、端末に該当曲を聴かせると楽曲を見つけてくれる楽曲検索機能）などのコンテンツもあります。',
        },
        {
          id: 8,
          business_direction: 'all',
          logo: 'logo_kkbox.jpg',
          name: 'KKBOX',
          description: '配信形式：ストリーミング\n配信地域：日本、台湾、香港、シンガポール\n試聴時間：30秒',
          note: 'KKBOXは2005年に台湾で設立・サービスが開始された、5000万曲以上の楽曲を配信しているアジア大手音楽ストリーミングサービスです。登録者数は1000万人以上。世界最大数のC-POP（中華圏の大衆音楽のことを指し、標準中国語や広東語で歌詞の基礎が構成されている楽曲）をラインナップ。豊富なプレイリストがあり、アーティストや音楽ライターが作成したオリジナリティあふれるプレイリストをデイリー更新しています。チャット機能「Listen with」は、オンライン中の有名人やDJをリアルタイムに確認・チャットを開始することができます。日本国内のコンサート映像だけでなく、国外アーティストのコンサート映像も生配信で見ることができます。',
        },
        {
          id: 9,
          business_direction: 'all',
          logo: 'logo_utapass.png',
          name: 'auスマートパスプレミアムミュージック',
          description: '配信形式：ラジオ型ストリーミング ※1\n配信地域：国内\n試聴時間：30秒',
          note: 'auスマートパスプレミアムミュージックは、auが手がける音楽ストリーミングサービスです。auスマートパスプレミアム会員なら追加料金なしで利用でき、またauIDを持っていれば、auユーザーでなくても利用可能です。\n10,000を超える豊富なプレイリストが用意されており、邦楽・洋楽など問わず、世代別・シチュエーション別に選べるプレイリストが揃っています。アーティストがパーソナリティーを務めるオリジナル番組Backstage Caféを独占配信しています。',
        },
        {
          id: 10,
          business_direction: 'all',
          logo: 'logo_recotyoku.jpg',
          name: 'レコチョク',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：44秒',
          note: 'レコチョクは株式会社レコチョクが運営する「レコチョク」をはじめ、同社が共同で企画・運営している配信ストアを含む９つの音楽配信ストアの総称です。「レコチョク」はさまざまな端末（ＰＣ、スマートフォン、タブレット、等）で利用可能となっており、楽曲・動画のデジタルコンテンツを多くのユーザーにダウンロード配信、及びストリーミング配信を行う事が可能です。国内最大級の配信数を誇る楽曲のなかから、月額登録不要で好きな時に1曲から購入するこが可能です。\n購入した楽曲は無料で何度でもダウンロードすることができます。',
        },
        {
          id: 11,
          business_direction: 'all',
          logo: 'logo_otoraku.jpg',
          name: 'OTORAKU',
          description: '配信形式：ラジオ型ストリーミング ※1\n配信地域：国内\n試聴時間：44秒',
          note: 'OTORAKUはUSENが運営する、お店の利用に特化した「BGMアプリ」です。\nスマホやタブレット端末を使用するので、初期費用も低コストで抑えられ、面倒な設置工事も不要で、カンタンに導入が可能です。万が一お店の環境により工事が必要な場合は、USENのプロの技術者が実施します。\n著作権処理済みの約950万曲以上の豊富な楽曲を使って、自分のお店だけのプレイリストを作ることができ、他店との差別化も有効的であり、既存プレイリストも600以上揃えています。',
        },
        {
          id: 12,
          business_direction: 'all',
          logo: 'logo_d_hits.jpg',
          name: 'dヒッツ',
          description: '配信形式：ラジオ型ストリーミング ※1\n配信地域：国内\n試聴時間：パソコンサイト24秒、スマートフォンアプリ30秒',
          note: 'dヒッツはNTTドコモが提供している定額制音楽ストリーミングサービスです。NTTドコモユーザー以外でも無料のdアカウント登録をすれば、dヒッツの利用が可能です。J-POP、洋楽、アニソンなどフルバージョンで9,500以上のプレイリストが聴き放題。好きな曲を「myヒッツ」に保存することで、いつでもどこでも好きな時に好きな曲が聴け、myヒッツは毎月10曲ずつ、年間で最大120曲保存が可能です。「myヒッツ」保存した楽曲と、スマートフォンに保存している楽曲を合わせて、オリジナルのプレイリストが作成できます。プレイリストの楽曲について、歌詞表示もあります。',
        },
        {
          id: 44,
          business_direction: 'all',
          logo: 'logo_weddingmusicbox.jpg',
          name: 'WEDDING MUSIC BOX',
          description: '配信形式：BGMサービス\n配信地域：国内',
          note: 'レコチョクが株式会社USENと協業で展開するウェディング演出に特化したBGMサービスパッケージです。\n結婚式シーンを彩るBGMの選曲・管理、披露宴での再生、複雑な権利処理までワンストップ運用が「Web」＋「アプリ」のオンラインで可能になります。',
        },
        {
          id: 14,
          business_direction: 'all',
          logo: 'logo_d_music.jpg',
          name: 'dミュージック powered by レコチョク',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：44秒',
          note: '国内最大級の音楽配信ストアです。1100万曲以上の豊富なラインナップが揃っています。\n試聴も可能でお気に入りの曲はワンクリックで購入可能です。\n楽曲購入時と同じdアカウントでログインをすれば、最大10台まで、複数端末で利用できます。ダウンロード型のためパケット通信料はかからず、何回でもダウンロード・再生が可能で、購入楽曲はプレーヤーアプリにて再生できます。dヒッツとの親和性もあるため、dヒッツをご契約の方はdヒッツアプリでも利用可能です。',
        },
        {
          id: 16,
          business_direction: 'all',
          logo: 'logo_music_store.jpg',
          name: 'Music Store powered by レコチョク',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：44秒',
          note: 'auの方もau以外の方もどなたでもご利用できる1曲から購入可能な音楽ダウンロードサイトです。好きなアーティストを登録すると、新曲の配信開始や、お得な商品情報をPUSH通知でお知らせしてくれます。スマートフォン・タブレット・パソコンなど複数の端末で対応可能です。',
        },
        {
          id: 17,
          business_direction: 'all',
          logo: 'logo_rakuten_music.jpg',
          name: '楽天 MUSIC',
          description: '配信形式：ストリーミング\n配信地域：国内\n試聴時間：30秒',
          note: '楽天株式会社が運営する定額制のストリーミング音楽配信サービスです。「Rakuten Music」は、スマートフォン・タブレット端末(iOS/Android)で利用可能となっており、“One-Stop Music Service”をコンセプトに、2016年8月に開始した楽天グループの新しいサービスです。\n定額で音楽を好きなだけ聴けるだけでなく、気に入った楽曲のCDなどをスムーズに購入できるよう設計開発されており、利用登録したユーザーは、スマートフォンやタブレットで好みの楽曲やアーティストを選び、いつでもどこでもストリーミング再生可能です。',
        },
        {
          id: 18,
          business_direction: 'all',
          logo: 'logo_youtube_music.jpg',
          name: 'YouTube Music',
          description: '配信形式：ストリーミング\n配信地域：国内/海外\n試聴時間：試聴機能なし',
          note: 'YouTubeが提供する音楽ストリーミングサービスです。「YouTube Music」では、アートトラック（動画がなく音楽だけの公式配信）とともにYouTube上の音楽コンテンツや公式ミュージックビデオなどが、さまざまな端末（PC、スマートフォン、タブレット等）で利用が可能で、有料会員であれば、広告が表示されず、アプリ上でオフライン再生やバックグラウンド再生、画面ロック中の再生も可能です。\n特徴的なのは機械学習を活用してパーソナライズしたレコメンド（おすすめ）コンテンツです。ユーザーの好みに沿った曲をまとめてプレイリストを作成するのはもちろん、ユーザーのテイストに合いそうなミュージシャンや楽曲をおすすめしてくれます。さらに、時間や場所によって、異なる内容のプレイリストを作成してくれます。\nプレイリストが並ぶホームのほかに、ホットリスト、ライブラリーという2つのページに切り替えられます。ホットリストは、そのときに流行している音楽や動画を視聴できるページで、今日本ではどんな曲が聴かれているのか、どのアーティストが盛り上がっているのか、トレンドとなるコンテンツばかりが集められています。\nライブラリーは、自分で作成できるプレイリストです。お気に入りの曲（動画）を見つけてライブラリーに追加しておけば、次回からは再び検索する必要なく視聴可能です。なお、ライブラリーに追加した楽曲は、機械学習のもとになるデータとして活用されます。',
        },
        {
          id: 19,
          business_direction: 'all',
          logo: 'logo_dwango.jpg',
          name: 'ドワンゴジェイピー',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：45秒',
          note: '様々なジャンルを網羅した音楽配信総合サイトです。',
        },
        {
          id: 20,
          business_direction: 'all',
          logo: 'logo_animelo-mix.jpg',
          name: 'animelo mix（アニメロミックス）',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：45秒',
          note: 'アニメ総合エンタメサイト。アニソンを中心とした様々なコンテンツを提供しています。',
        },
        {
          id: 21,
          business_direction: 'all',
          logo: 'logo_K-POP-Life.jpg',
          name: 'K-POP Life',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：45秒',
          note: 'K-POP・韓国ドラマの音楽を中心としたラインナップで提供しています。',
        },
        {
          id: 22,
          business_direction: 'all',
          logo: 'logo_billboard.jpg',
          name: 'ビルボード公式 (Billboard x dwango)',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：45秒',
          note: '洋楽専門サイトです。',
        },
        {
          id: 23,
          business_direction: 'all',
          logo: 'logo_dwango-sugotoku.jpg',
          name: 'ドワンゴジェイピー for スゴ得',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：45秒',
          note: 'NTT docomoが提供する「スゴ得」コンテンツ契約者が利用できる、ドワンゴジェイピーサービス。会員数は500万人を超えています。',
        },
        {
          id: 24,
          business_direction: 'all',
          logo: 'logo_deezer.jpg',
          name: 'Deezer',
          description: '配信形式：ストリーミング\n主な配信国:国内を含む全世界\n本拠地：フランス',
          note: 'HiFi音質での配信などが特徴の欧米でポピュラーな音楽ストリーミングストアです。世界188カ国で利用されている中、現在、アジア方面へのサービス拡大を進めています。',
        },
        {
          id: 25,
          business_direction: 'all',
          logo: 'logo_jiosaavn.jpg',
          name: 'JioSaavn',
          description: '配信形式：ストリーミング\n主な配信国:インド\n本拠地：インド',
          note: 'インドを中心に近辺5カ国(現在拡大中)で展開されています。楽曲はBollywood中心で、登録会員数は1億400万人を超えています。',
        },
        {
          id: 26,
          business_direction: 'all',
          logo: 'logo_anghami.jpg',
          name: 'Anghami',
          description: '配信形式：ストリーミング\n主な配信国:中東、北アフリカ地域(バーレーン, アルジェリア, エジプト, イラク, ヨルダン, クウェート, レバノン, リビア, モロッコ, オマーン, パレスチナ, カタール, サウジアラビア, スーダン, シリア, チュニジア, アラブ, イ エメン)\n本拠地：アラブ首長国連邦',
          note: '中東〜北アフリカ諸国でYouTubeに次ぐ利用者数を抱える音楽サービスです。登録ユーザー数7000万人以上です。',
        },
        {
          id: 27,
          business_direction: 'all',
          logo: 'logo_qqmusic.jpg',
          name: 'QQ Music（キューキューミュージック）',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：中国\n本拠地：中国',
          note: 'QQ Musicはテンセント・ミュージック傘下の音楽ストリーミング/ダウンロードサービスです。\nアクティブユーザー数は約4億人。\nユーザー年齢層は20代以下が中心で、ポピュラー音楽の人気が高いです。\n配信楽曲数は4000万曲を超え、そのうち150万曲は日本語楽曲です。コンテンツの正規化に早くから取り組み、アプリ経由で音楽ライブを中継するなど、音楽配信だけに留まらない総合音楽プラットフォームとしての地位を築いてきました。',
        },
        {
          id: 28,
          business_direction: 'all',
          logo: 'logo_kugou.jpg',
          name: 'Kugou Music（クゴウミュージック）',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：中国\n本拠地：中国',
          note: 'Kugou Musicはテンセント・ミュージック傘下の音楽ストリーミング/ダウンロードサービスです。\nアクティブユーザー数は約4億人。\nユーザー年齢層は均一的で、インディペンデントなアーティストの人気が高いです。\n配信楽曲数は4000万曲を超え、そのうち150万曲は日本語楽曲です。',
        },
        {
          id: 29,
          business_direction: 'all',
          logo: 'logo_kuwo.jpg',
          name: 'Kuwo Music（クウォミュージック）',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：中国\n本拠地：中国',
          note: 'Kuwo Musicはテンセント・ミュージック傘下の音楽ストリーミング/ダウンロードサービスです。\nアクティブユーザー数は約1億人。\nユーザー年齢層が若く、日韓音楽の人気が高いです。\n配信楽曲数は4000万曲を超え、そのうち150万曲は日本語楽曲です。',
        },
        {
          id: 30,
          business_direction: 'all',
          logo: 'lgo_wesing.jpg',
          name: 'We Sing（ウィーシング）',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：中国\n本拠地：中国',
          note: 'We Singはテンセント・ミュージック傘下のオンラインカラオケサービスアプリです。\nアクティブユーザー数は約1.5億人。女性ユーザーが多く、SNS機能やライブラリが充実しています。\n機能としては日本のカラオケのように採点機能やソーシャルでの共有機能などがあり、インスト楽曲を主に配信しています。',
        },
        {
          id: 43,
          business_direction: 'all',
          logo: 'logo_ultimatemusic.jpg',
          name: 'Ultimate Music',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：中国\n本拠地：中国',
          note: 'Ultimate Music（爱听卓乐）は、テンセントミュージック系列の音楽サービスです。\n提供楽曲数は600万曲以上です。中国国内の各種スマホ端末や車のスマートシステム、オンラインプレイヤーへ楽曲を提供しています。',
        },
        {
          id: 31,
          business_direction: 'all',
          logo: 'logo_7digital.jpg',
          name: '7digital',
          description: '配信形式：ストリーミング/ダウンロード\n主な配信国：イギリス、アイルランド、スペイン、フランス、ドイツ\n本拠地：EU',
          note: '7digital（セブン・デジタル）は、ワーナー・ミュージック・グループがヨーロッパの一部の国で展開している音楽配信サービスです。世界中の音楽やラジオ局への簡単なアクセスを可能にし、デジタル音楽パートナー向けの BtoB サービスと、企業やブランドによる D2C 音楽ダウンロードサービスを提供しています。同社のスケーラブルなデジタル音楽プラットフォームと柔軟性に優れた API は、包括的な音楽およびラジオサービスの提供をサポートし、大手消費者ブランドやモバイルキャリア、ハードウェアメーカー、放送局などで使用されています。7digital のグローバルカタログには2,700万以上の楽曲が含まれており、世界20か国の利用者が、www.7digital.com のミュージックストアや、世界中で6,000万台以上のデバイスにプリインストールされている 7digital ブランドのモバイルアプリを通じて音楽を購入しています。\n※7digitalが提携するストアへ配信される場合がございます。',
        },
        {
          id: 34,
          business_direction: 'all',
          logo: 'logo_pandora.jpg',
          name: 'Pandora',
          description: '配信形式：ラジオ型ストリーミング ※1\n主な配信国:アメリカ, カナダ\n本拠地：アメリカ',
          note: 'アメリカで人気のネットラジオサービスです。2013年時点で登録者数は2億人を超えており、ネットラジオ界ではもっとも視聴時間の⻑いサービスとして知られています。',
        },
        {
          id: 35,
          business_direction: 'all',
          logo: 'logo_shazam.jpg',
          name: 'Shazam',
          description: '配信形式：ディスカバリーデータベースへの登録\n主な配信国:国内を含む全世界\n本拠地:アメリカ(Apple Incが所有)',
          note: '音声検索サービスです。流れている楽曲や鼻歌を認識することで、その楽曲の情報や音楽配信メディアへのリンクを得ることができます。\n※Shazamのデータベースへ登録した場合でも、Shazam上では楽曲の再生がないため、ロイヤリティは発生しません。',
        },
        {
          id: 36,
          business_direction: 'all',
          logo: 'logo_soundcloud.jpg',
          name: 'SoundCloud',
          description: '配信形式：ストリーミング\n主な配信国:ドイツ,アメリカ, イギリス,スペイン,フランス,イタリア,オランダ,ブラジル,ポルトガル\n本拠地：ドイツ',
          note: 'ドイツに拠点を置く、全世界で2億人ほどが利用している音楽共有サービスです。世界中のクリエイターたちが様々な音楽を登録しています。\n※現状、日本では有料プラン(SoundCloud Goなど)はローンチされておらず、無料かつ広告なし・オンデマンドで楽曲を全再生できる状況です。\n※日本での配信においては、再生によるロイヤリティは発生しません。',
        },
        {
          id: 37,
          business_direction: 'all',
          logo: 'logo_facebook_Instagram_music_stamp.jpg',
          name: 'Facebook/Instagramミュージックスタンプ',
          description: '配信形式：ストリーミング\n主な配信国:国内を含む全世界\n本拠地：アメリカ',
          note: 'Facebookが運営するアプリ/サービスであるFacebookやInstagramなどに楽曲を登録し、SNSユーザーがあなたの楽曲をスタンプとして利用ができます。\nまた、その他、動画・プロフィールなどで利用(最大15秒)することも可能です。\n※Facebook /Instagramミュージックスタンプは、ユーザーが無料で使えるサービスです。',
        },
        {
          id: 38,
          business_direction: 'all',
          logo: 'logo_mixcloud.jpg',
          name: 'Mixcloud',
          description: '配信形式：ラジオ型ストリーミング\n主な配信国:イギリス,アメリカ,イタリア,オランダ,スウェーデン,スペイン,デンマーク,ドイツ,フランス,ベルギー,ポーランド,ポルトガル\n本拠地：イギリス',
          note: 'DJミックスやポッドキャストに強い、英国のオンライン音楽ストリーミングサービスです。\nDJをはじめとするユーザーに支持されユーザー数を伸ばし、300万人以上のアクティブユーザーが利用しています。',
        },
        {
          id: 39,
          business_direction: 'all',
          logo: 'logo_tiktok.jpg',
          name: 'TikTok',
          description: '配信形式：ストリーミング\n主な配信国:国内を含む全世界\n本拠地：中国',
          note: '全世界で10億人以上が利用するショートムービーアプリです。TikTok上のトレンドに乗り、新たな人気を獲得したアーティストの例も多く、全世界への楽曲認知につながることで、 大きなプロモーション効果が期待できます。\n※TikTokは、ユーザーが無料で使えるサービスです。',
        },
        {
          id: 40,
          business_direction: 'all',
          logo: 'logo_gracenote.jpg',
          name: 'Gracenote',
          description: '配信形式：ディスカバリーデータベースへの登録\n主な配信国:国内を含む全世界\n本拠地：アメリカ',
          note: 'Grecenoteは音楽認識技術による楽曲データベース作成をおこなうメタデータ企業です。Grecenoteにデータベース登録をするとiTunes, Spotify, Amazonなどの音楽配信ストアや、トヨタやメルセデスなどの自動車メーカーのシステムで活用されます。\n※データベースへの登録のみとなる為、ロイヤリティは発生しません。',
        },
        {
          id: 41,
          business_direction: 'all',
          logo: 'logo_flo.jpg',
          name: 'FLO',
          description: '配信形式：ストリーミング\n主な配信国：韓国\n本拠地：韓国\n試聴時間：60秒「FLOは視聴開始位置の設定は反映されません。\n曲の一番初めから60秒が試聴となります。」\n',
          note: 'FLOはDreamus Companyが運営する韓国の音楽ストリーミングサービスです。\n6,000万曲以上の楽曲が視聴可能、11万2,000以上のプレイリストがあります。\nレーベルとの提携は800以上、アクティブユーザー数は210万人を超え、韓国の音楽市場シェアの15％を占める大手の音楽配信ストアです。\nAIによる楽曲提案、チャート中心ではなくリスナーひとりひとりに合った楽曲を発掘できる機能が充実しています。\nまたリスナーごとにパーソナライズされたプレイリストは毎月更新され、その時々のプレイリストを楽しむことができます。',
        },
        {
          id: 42,
          business_direction: 'all',
          logo: 'logo_mora.png',
          name: 'mora',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：最大45秒間\n※1分未満の楽曲は試聴なし\n',
          note: 'mora（モーラ）は、日本の音楽ダウンロード・音楽配信サイトです。WALKMAN公式ミュージックストアとして始まり、現在では1000万曲以上の邦楽・洋楽やミュージックビデオがブラウザやアプリから楽しめます。名盤から最新のヒット曲をロスレス・ハイレゾ・DSD音源などで取り揃えており、高音質にこだわったサービスが魅力です。',
        },
        {
          id: 43,
          business_direction: 'all',
          logo: 'logo_melon.jpg',
          name: 'Melon',
          description: '配信形式：ストリーミング/ダウンロード\n配信地域：韓国\n本拠地：韓国\n',
          note: 'Melonは韓国発の主要音楽配信サービスです。幅広い音楽ジャンルを提供し、特にK-POPに焦点を当てています。\nユーザーは、豊富な楽曲ライブラリを通じて最新のK-POPや国際的なヒット曲にアクセスでき、リアルタイムの音楽チャートの提供により人気曲を把握できます。\nさらに、様々なプレイリストやラジオ機能を利用して、好みに合った音楽を見つけることができるなど機能が充実しています。\n音楽以外にも、アーティストの最新情報や公演スケジュールなども提供され、K-POPファンにとっては必須のアプリとなっています。',
        },
        {
          id: 44,
          business_direction: 'all',
          logo: 'logo_netease.jpg',
          name: 'NetEase',
          description: '配信形式：ストリーミング\n主な配信エリア：中国',
          note: 'NetEase,Inc.が2013年に立ち上げた、活気あるコンテンツコミュニティが特徴の配信ストア。\n中国内の音楽ファンの間で、新しいインディーズ音楽を探す場所として機能しており、活発なZ世代コミュニティの間で最も人気のあるエンタテインメントアプリとして評価されています。',
        },
        {
          id: 45,
          business_direction: 'all',
          logo: 'logo_bugs.jpg',
          name: 'Bugs!',
          description: '配信形式：ストリーミング、ダウンロード\n主な配信エリア：韓国',
          note: '老舗の配信ストアで多様なジャンルの音楽を取り扱っているためコアな音楽ファンユーザーが多く、高音質での配信にも力を入れています。',
        },
        {
          id: 46,
          business_direction: 'all',
          logo: 'logo_vibe.jpg',
          name: ' VIBE',
          description: '配信形式：ストリーミング、ダウンロード\n主な配信エリア：韓国',
          note: '韓国最大の検索エンジン企業NAVERが提供しており、独自技術を活かしたAIレコメンド機能によって新人アーティストでも発見されやすい仕組みになっています。',
        },
        {
          id: 47,
          business_direction: 'all',
          logo: 'logo_genie.jpg',
          name: 'Genie',
          description: '配信形式：ストリーミング、ダウンロード\n主な配信エリア：韓国',
          note: '韓国ではMelonに次ぐユーザー数であり、韓国で唯一の5Gベースの24bit Free Lossless Audio Code（FLAC）音楽サービスを運営するなど市場をリードしている配信ストアです。',
        },
        {
          id: 48,
          business_direction: 'all',
          logo: 'logo_tidal.jpg',
          name: 'TIDAL',
          description: '配信形式：ストリーミング\n主な配信エリア：海外',
          note: 'TIDALはTIDAL社が運営する音楽配信サービスで、ユニークな体験と最高の音質でファンとアーティストの距離を縮める、グローバルな音楽ストリーミングプラットフォームです。\nロスレスのオーディオ体験やHiFi音質での視聴にも対応しており、アーティストの想いに限りなく近い音楽体験を実現する音楽配信の場を提供しています。',
        },
        {
          id: 49,
          business_direction: 'all',
          logo: 'logo_qobuz.jpg',
          name: 'Qobuz',
          description: '配信形式：ストリーミング、ダウンロード\n主な配信エリア：国内/海外',
          note: '「Qobuz」は2007年にフランスで設立された、ハイレゾをはじめとする高音質音源の取り扱いを強化しているサービスです。\n高音質音楽配信の先駆者としてストリーミングとダウンロードの両方を提供しています。インタビュー記事や特集記事などのエディトリアルコンテンツのクオリティ、そしてレコメンデーションのクオリティで、他の音楽配信サイトとは一線を画すプラットフォームです。',
        },
        {
          id: 50,
          business_direction: 'all',
          logo: 'logo_music_jp.jpg',
          name: 'music.jp',
          description: '配信形式：ダウンロード\n配信地域：国内\n試聴時間：90秒',
          note: '新J-POP・洋楽のヒット曲から懐かしの定番曲まで、様々なジャンルの楽曲を豊富に取り揃え、高音質で配信しています。パソコンやスマートフォン、タブレット端末に向けて、楽曲をダウンロード販売できます。',
        },
      ],
    }
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
  },
  mounted() {
    const businessDirection = this.isBtoB ? 'b2b' : 'b2c'
    this.lists = this.lists.filter(list => list.business_direction === 'all' || list.business_direction === businessDirection)
  },
}
</script>

<style scoped>
.c-btn-wrap {
  margin-top: 30px;
}
.store-detail-area__block--right--details {
  white-space: pre-line;
}
</style>
